import React, { useEffect, useState } from "react";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { LinearProgress } from "@mui/material";
import { NodeDetailsDto } from "../common/NodeDetailsDto";
import { NodeTreeItem } from "./components/node-tree-item";
import { TreeView } from "@mui/lab";
import { getNodeById } from "domains/nodes/services/node-service-helpers";
import { useHierarchyNodesSearchById } from "domains/nodes/services/use-hierarchynodes-api";

interface IProps {
    fieldCompanyId: number;
    onNodeSelect?: (nodeId: string, nodeDetails: NodeDetailsDto) => void;
    onToggle?: (nodeIds: string[]) => void;
    expandedNodes?: string[];
    selectedNodeId?: string;
    refresh?: boolean;
    onLoaded?: () => void;
    showNoPartitionsAllowedTooltip?: boolean;
}

const NodeTree = (props: IProps) => {
    const { loading, data, error, refresh } = useHierarchyNodesSearchById(props.fieldCompanyId);

    const [selectedNodeId, setSelectedNodeId] = useState(props.selectedNodeId ?? null);

    const [expandedNodes, setExpandedNodes] = useState(props.expandedNodes ?? []);

    useEffect(() => {
        if (!loading && !error && data?.hierarchyNodes.length) {

            if(!selectedNodeId){
                setSelectedNodeId(data.nestedHierarchyNodes[0].id.toString());
            }

            if (props.onLoaded) {
                props.onLoaded();
            }
        }
    }, [loading]);

    useEffect(() => {
        if (selectedNodeId && data?.hierarchyNodes.length) {
            const nodeDetails = getNodeById(selectedNodeId, data.hierarchyNodes);
            if (props.onNodeSelect && nodeDetails) {
                props.onNodeSelect(selectedNodeId, nodeDetails);
            }
        }
    }, [selectedNodeId, data]);

    useEffect(() => {
        if (expandedNodes && props.onToggle) {
            props.onToggle(expandedNodes);
        }
    }, [expandedNodes]);

    useEffect(() => {
        if (props.refresh) {
            refresh();
        }
    }, [props.refresh]);

    return (
        <>
            {loading && <LinearProgress/>}
            {!loading && selectedNodeId && data?.nestedHierarchyNodes.length && (
                <>
                    <TreeView
                        role={"node-tree-view"}
                        defaultCollapseIcon={<ArrowDropDownIcon />}
                        defaultExpandIcon={<ArrowRightIcon />}
                        defaultEndIcon={<div style={{ width: 24 }} />}
                        sx={{ flexGrow: 1, overflowY: "auto" }}
                        onNodeToggle={(_, nodeIds: string[]) => {
                            setExpandedNodes(nodeIds ?? []);
                        }}
                        selected={selectedNodeId}
                        defaultExpanded={[selectedNodeId]}
                        expanded={expandedNodes}
                        onNodeSelect={(_: React.SyntheticEvent, nodeId: string) => {
                            setSelectedNodeId(nodeId ?? null);
                        }}
                    >
                        <NodeTreeItem showNoPartitionsAllowedTooltip={props.showNoPartitionsAllowedTooltip} nodes={data.nestedHierarchyNodes}></NodeTreeItem>
                    </TreeView>
                </>
            )}
        </>
    );
};

export default NodeTree;
